import { render, staticRenderFns } from "./PH2L.vue?vue&type=template&id=45373dca&scoped=true"
import script from "./PH2L.vue?vue&type=script&lang=js"
export * from "./PH2L.vue?vue&type=script&lang=js"
import style0 from "./PH2L.vue?vue&type=style&index=0&id=45373dca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45373dca",
  null
  
)

export default component.exports